export default __webpack_public_path__ + "static/media/step-5.503734de.svg";